import ProductPageContent from "components/ProductPageContent";
import { PRODUCT_PAGES } from "data/productPages";

function CarvedFountainsPage() {
  return <ProductPageContent data={PRODUCT_PAGES["carved-fountains"]} />;
}

export default CarvedFountainsPage;
